import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ExternalTaskSchema } from './shapes';

/** Change a linked ClickUp task's status. The only supported external mutation. */
export const setReleaseTaskStatus = defineEndpoint({
  method: 'POST',
  path: '/v1/release-tasks/status',
  params: z.object({}),
  query: z.object({}),
  body: z.object({
    ref: z.string().trim().min(1).max(64),
    status: z.string().trim().min(1).max(100),
  }),
  response: z.object({ data: ExternalTaskSchema }),
});
